// Members ---------------------------------------------------------------------
import { catchHttpError, onStatus } from '../catchHttpError';
import { cloudEnterpriseEnrolmentApiClient as enrollmentApiClient } from '../clients/cloudEnterpriseEnrollmentApiClient';
import type { BillingAddress } from './cloudEnterpriseEnrollmentApi.types';

export const getStatus = async () =>
  catchHttpError(
    enrollmentApiClient
      .GET('/enrollment/v1/status')
      .then((res) => res.data ?? null),
    onStatus('NotFound', null) // Returns 404 when no enrollment is initiated
  );

export const initEnrollment = async (vars: {
  orgName: string;
  companyName: string;
  domain: string;
  billingEmail: string;
  duns: string;
  taxId: string;
  tos: boolean;
  billingAddress: BillingAddress;
  orderId: string;
}) =>
  await enrollmentApiClient
    .POST('/enrollment/v1/init', {
      body: {
        displayName: vars.orgName,
        companyName: vars.companyName,
        domain: vars.domain,
        billingEmail: vars.billingEmail,
        duns: vars.duns,
        taxId: vars.taxId,
        tos: vars.tos,
        billingAddress: vars.billingAddress,
        orderId: vars.orderId,
      },
      parseAs: 'text',
    })
    .then((r) => r.data ?? null);

export const updateConnection = async (vars: {
  certificate: string;
  signInUrl: string;
}) =>
  enrollmentApiClient
    .PUT('/enrollment/v1/connection', {
      body: {
        b64Certificate: vars.certificate,
        signInUrl: vars.signInUrl,
      },
      parseAs: 'text',
    })
    .then((r) => r.data ?? null);

export const verifyDomain = async () =>
  enrollmentApiClient
    .POST('/enrollment/v1/verify', {
      parseAs: 'text',
    })
    .then((r) => r.data ?? null);

export const cancelEnrollment = async () =>
  enrollmentApiClient.DELETE('/enrollment/v1/cancel', { parseAs: 'text' });

export const finalizeEnrollment = async () =>
  enrollmentApiClient.POST('/enrollment/v1/finalize', { parseAs: 'text' });
